import moment from "moment/moment";
import { useEffect, useState } from "react";
import CardHeaderDashboardOnOff from "../../../utils/cardHeaderDashboardOnOff";
import { useLocation, useOutletContext } from "react-router-dom";
import { requestToServer } from "../../../utils/appUtils";
import { Button } from 'primereact/button';
import { MainAreaHeader } from "../../../layout/MainArea";
import { GetConnPULSN } from "../../../../api";

const ROUTE_URL = "/conf_lsn";


const CardCHConn = (props) => {
    const token = localStorage.getItem('token')
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(2);
    const [date, setDate] = useState();
    const [onoff, setOnoff] = useState(props.butchState);
    const [loadingStatus, setLoadingStatus] = useState(true)

    const [serverData, setServerData] = useState(true);
    serverData?.data?.forEach((item) => {
        item.status = 0
    })
    const { showErrorPage, messageBox } = useOutletContext();


    // useEffect(() => {
    //     requestToServer(ROUTE_URL, { method: 'GET' }, setServerData, showErrorPage, true);
    // }, [])

    let servicesPrev = [
        { id: 1, name: "СПО АДМИНИСТРИРОВАНИЯ И КОНТРОЛЯ РАБОТОСПОСОБНОСТИ", status: "normal"},
        { id: 2, name: "СПО АУТЕНТИФИКАЦИИ ПОТРЕБИТЕЛЕЙ", status: "normal"},
        { id: 3, name: "СПО ВЗАИМОДЕЙСТВИЯ СО СМЕЖНЫМИ И ВНЕШНИМИ ИНФОРМАЦИОННЫМИ СИСТЕМАМИ", status: "normal"},
        { id: 4, name: "СПО ТЕСТИРОВАНИЯ И УСТРАНЕНИЯ ИНЦИДЕНТОВ", status: "normal"},
    ];

    const [services, setServices] = useState(servicesPrev)


 useEffect(() => {
            window.timer = setInterval(async () => {
                setLoadingStatus(true);
                await GetConnPULSN(token).then( (e) => {
                    let arr = [];
                    arr.push({id: 1, name: `СПО АДМИНИСТРИРОВАНИЯ И КОНТРОЛЯ РАБОТОСПОСОБНОСТИ`, status: "normal"})
                    for(let i = 0; i < e.data.results.length; i++) {
                        arr.push({id: i + 2, name: e.data.results[i].name, status: e.data.results[i].success ? "normal" : "failed"})
                    }
                    setServices(arr)
                })
                setLoadingStatus(false);

                  }, 30000);
                }, [])

const handleClick = (event) => {
    if (loading) return;
   event && event.preventDefault();
   event && event.target.blur();
    //    refreshData();
    setLoadingStatus(true);
    GetConnPULSN(token).then( (e) => {
        let arr = [];
        arr.push({id: 1, name: `СПО АДМИНИСТРИРОВАНИЯ И КОНТРОЛЯ РАБОТОСПОСОБНОСТИ`, status: "normal"})
        for(let i = 0; i < e.data.results.length; i++) {
            arr.push({id: i + 2, name: e.data.results[i].name, status: e.data.results[i].success ? "normal" : "failed"})
        }
        setServices(arr)
        setLoadingStatus(false);

    })
    setDate(Date.now())
    // setTimeout(() => {
    //     setLoadingStatus(false);
    // }, 650);
}

  

   


    useEffect(() => {
        handleClick()
      }, [])
      useEffect(() => {
        window.timer = setInterval(async () => {
            // handleClick()
        }, 30000);
            }, [])
    

    let styleCard = {};
    let classCard = "card h-100";
    if (props.dashboard === false) {
        styleCard = { minHeight: "var(--clientheight)" };
        classCard = "card border-0";
    }

    return (
        <div className={classCard} style={styleCard}>
            <MainAreaHeader caption="СПО ПУ-ЛСН" />

            <div className="card-body" style={{ fontSize: "0.85rem" }}>
                {(
                    services?.map((item, index, array) => {
                        return (
                            
                            <div key={item.id} className={`gap-2 col-12 d-flex align-items-center ${index == 0 ? "" : "mt-1"}`}>
                                {loadingStatus ? (
                                    <div style={{ width: "1.25em", height: "1.25em", margin: `6.5px 0px` }} className=" spinner-border spinner-border-sm text-primary"></div>
                                ) : (
                                    <i className={`fs-5 ${item.status == "normal" ? "bi-check-circle-fill text_green" : item.status == "failed" || item.status === "missing" ? "bi-x-circle-fill text-danger" :  "bi-check-circle-fill text_yellow" }`}></i>
                                )}
                                <div>
                                    <span className="link-info">
                                        {item.address ? <a className="link-info" href={`${item.address}`}>{item.name}</a> : item.name} 
                                      {/*  - <small>{moment(item.date).isValid() ? moment.utc(item.date).local().format("DD.MM.YYYY HH:mm:ss") : item.date}</small> */}
                                    </span>
                                </div>
                            </div>
                   
                        );
                    })
                )}
                   <div className="lower-line">
                     <div className="text-cont">
                         <div className="text">Состояние актуально на:</div>
                         <div className="text">{date ? new Date(date).toLocaleString() : ""}</div>
                     </div>
                     <Button className="btn-reload" loading={loading} label="Обновить сейчас" rounded onClick={handleClick}/>
                 </div>
            </div>
        </div>
    );
}

export default CardCHConn;